import { DispatcherPermissionValue } from "@/api/dto/dispatcher.dto";

export enum Role {
  admin = "ad",
  teamLead = "tl",
  booking = "bk",
  hr = "hr",
  operation = "op",
  accounting = "ac",
}

export const RoleMap: Record<Role, string> = {
  [Role.admin]: "Admin",
  [Role.teamLead]: "Team Lead",
  [Role.booking]: "Booking",
  [Role.hr]: "HR",
  [Role.operation]: "Operation",
  [Role.accounting]: "Accounting",
};

export enum MenuSection {
  dispatchers = "dispatchers",
  drivers = "drivers",
  owners = "owners",
  trucks = "trucks",
}

export enum RoleAction {
  view = "view",
  edit = "edit",
  delete = "delete",
}

export enum NavigationItem {
  account = "account",
  dashboard = "dashboard",
  chat = "chat",
  coordinators = "coordinators",
  dispatchers = "dispatchers",
  drivers = "drivers",
  carriers = "carriers",
  company = "company",
  customers = "customers",
  facilities = "facilities",
  orders = "orders",
  owners = "owners",
  trips = "trips",
  trucks = "trucks",
  logs = "logs",
  users = "users",
  reports = "reports",
}

export const NavigationPermissionMap: Record<NavigationItem, DispatcherPermissionValue[]> = {
  [NavigationItem.account]: [],
  [NavigationItem.dashboard]: [],

  [NavigationItem.chat]: [DispatcherPermissionValue.ChatList],

  [NavigationItem.coordinators]: [],
  [NavigationItem.dispatchers]: [DispatcherPermissionValue.DispatchersList],

  [NavigationItem.drivers]: [],
  [NavigationItem.carriers]: [],
  [NavigationItem.company]: [DispatcherPermissionValue.CompaniesList],

  [NavigationItem.customers]: [],
  [NavigationItem.facilities]: [],
  [NavigationItem.orders]: [DispatcherPermissionValue.OrdersList],

  [NavigationItem.owners]: [],
  [NavigationItem.trips]: [DispatcherPermissionValue.TripsInfo],

  [NavigationItem.trucks]: [DispatcherPermissionValue.TrucksList],

  [NavigationItem.logs]: [],
  [NavigationItem.users]: [DispatcherPermissionValue.UsersList],

  [NavigationItem.reports]: [DispatcherPermissionValue.ReportsList],
};
